<!-- Button to trigger the modal -->
<!-- ng-templates for text and icon -->
<ng-template #textTemplate>
  {{uploadTitle ?? 'Upload File'}}
</ng-template>

<ng-template #iconTemplate>
  <ods-icon slot="icon" variant="upload"></ods-icon>
</ng-template>

<!-- Button with conditional content based on uploadStyle text or icon only (Cory said to be more Dynamic) -->
<ods-button variant="primary" (click)="showModal = true">
  <ng-container *ngTemplateOutlet="uploadStyle === 'text' ? textTemplate : iconTemplate"></ng-container>
</ods-button>


<!-- Modal structure -->
<div class="modal" *ngIf="showModal">
  <div class="modal-content">
    <span class="close" (click)="close()">&times;</span> <!-- Close button -->
    <h2>Upload Document</h2> <!-- Modal title -->
    <p>Select "Choose File" to browse and upload a document.</p> <!-- Instructions -->
    
    <!-- File input hidden; revealed by button click -->
    <input type="file" #fileInput [attr.multiple]="uploadMode === 'multiple' ? 'multiple' : null" 
           (change)="onFileSelected($event)" hidden>
    <ods-button variant="tertiary" (click)="fileInput.click()">Choose File</ods-button> <!-- Button to trigger file input -->
    
    <!-- Display the name of the selected file in single upload mode -->
    <div *ngIf="uploadMode === 'single' && selectedFile">
      <p>Selected file: {{selectedFile.name}}</p>
    </div>
    
    <!-- List of file names in multiple upload mode -->
    <div *ngIf="uploadMode === 'multiple' && selectedFile.length">
      <ul>
        <li *ngFor="let selectedFile of selectedFile">{{ selectedFile.name }}</li>
      </ul>
      <small>total: {{selectedFile.length}}</small>
    </div>
    
    <!-- Display any file-related error messages -->
    <p *ngIf="fileError" class="error">{{ fileError }}</p>
    
    <!-- Display file upload constraints -->
    <!-- <p>Maximum file size is {{this.maxFileSizeMB}}</p>
    <p>Accepted file formats include: .bmp, .doc, .docx, etc.</p> -->
    
    <!-- Footer Buttons to open files or close the modal -->
    <div class="modal-footer">
      <ods-button variant="primary"(click)="uploadFile()">Upload</ods-button>
      <ods-button variant="secondary"(click)="close()">Cancel</ods-button>
    </div>
  </div>
</div>
